(() => {
  'use strict';

  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initialise(viewport) {
    if (viewport.dataset.marqueeReady === 'true') return;

    const track = viewport.querySelector('.cc-home-products__track');
    const list = track?.querySelector('.cc-home-products__grid');
    if (!track || !list || list.children.length < 2) return;

    viewport.dataset.marqueeReady = 'true';
    let frameId = 0;
    let lastTime = 0;
    let offset = 0;
    let pixelsPerMs = 0;
    let paused = false;

    const gap = () => parseFloat(window.getComputedStyle(list).columnGap || window.getComputedStyle(list).gap || '0');

    function measure() {
      const items = Array.from(list.children);
      const cycleWidth = items.reduce((total, item) => total + item.getBoundingClientRect().width, 0)
        + gap() * Math.max(0, items.length - 1);
      const duration = Math.max(18, Number(viewport.dataset.duration || 32));
      pixelsPerMs = cycleWidth / (duration * 1000);
    }

    function resetMotion() {
      window.cancelAnimationFrame(frameId);
      frameId = 0;
      lastTime = 0;
      offset = 0;
      track.style.transform = '';
    }

    function animate(now) {
      if (!lastTime) lastTime = now;
      const elapsed = Math.min(64, now - lastTime);
      lastTime = now;

      if (!paused && !document.hidden) {
        offset += elapsed * pixelsPerMs;
        let first = list.firstElementChild;
        while (first) {
          const step = first.getBoundingClientRect().width + gap();
          if (offset < step) break;
          offset -= step;
          list.append(first);
          first = list.firstElementChild;
        }
        track.style.transform = `translate3d(${-offset}px, 0, 0)`;
      }

      frameId = window.requestAnimationFrame(animate);
    }

    function start() {
      resetMotion();
      if (motionQuery.matches) return;
      measure();
      frameId = window.requestAnimationFrame(animate);
    }

    viewport.addEventListener('pointerenter', () => { paused = true; });
    viewport.addEventListener('pointerleave', () => { paused = false; lastTime = 0; });
    viewport.addEventListener('focusin', () => { paused = true; });
    viewport.addEventListener('focusout', (event) => {
      if (!viewport.contains(event.relatedTarget)) {
        paused = false;
        lastTime = 0;
      }
    });

    const resizeObserver = new ResizeObserver(() => {
      if (!motionQuery.matches) measure();
    });
    resizeObserver.observe(viewport);
    motionQuery.addEventListener?.('change', start);
    start();
  }

  function boot() {
    document.querySelectorAll('[data-home-products-marquee]').forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
